import { CampaignStatus } from "../../domain/types/campaign";
// Canonical 3-value model. Themes are OPAL design-system tokens.
const STATUS_CONFIG = {
    // Grey, not yellow: AC 4's legend files « brouillon » under neutre/gris, and the V2 Pilotage
    // frame draws this very badge with `badge-neutral-bg` (Figma 29099:33169). Yellow is the
    // legend's « principal / en cours ».
    [CampaignStatus.Draft]: { theme: "neutral", labelKey: "campaigns.status.Draft" },
    [CampaignStatus.Active]: { theme: "green", labelKey: "campaigns.status.Active" },
    [CampaignStatus.Completed]: { theme: "indigo", labelKey: "campaigns.status.Completed" },
};
/**
 * Resolve the badge theme + label key for a campaign status (neutral fallback).
 *
 * Extracted out of `CampaignStatusBadge.vue` so surfaces that cannot render that component —
 * the contextual navbar, which takes a `{ label, theme }` config rather than a slot — resolve the
 * same mapping instead of duplicating it. Mirrors `resolveActionStatusBadge`.
 */
export function resolveCampaignStatusBadge(status) {
    return STATUS_CONFIG[status] ?? { theme: "neutral", labelKey: status };
}
